module.exports = __webpack_public_path__ + "static/media/warranty_bottom_nova.fadac1b4.png";